import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface GlobalLoading {
  loading: boolean;
}
const initialState: GlobalLoading = {
  loading: false,
};

const GlobalLoadingSlice = createSlice({
  name: 'globalLoading',
  initialState,
  reducers: {
    updateGlobalLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
export const { updateGlobalLoading } = GlobalLoadingSlice.actions;
export default GlobalLoadingSlice.reducer;
